"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [(0, jsx_runtime_1.jsx)("circle", {
      cx: "10",
      cy: "10",
      r: "10",
      transform: "rotate(180 10 10)",
      fill: "#009CDE"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M10.2225 4.81543C9.78452 4.81543 9.42944 5.17051 9.42944 5.60852C9.42944 6.04653 9.78452 6.40161 10.2225 6.40161C10.6605 6.40161 11.0156 6.04653 11.0156 5.60852C11.0156 5.17051 10.6605 4.81543 10.2225 4.81543Z",
      fill: "#FFFFFF"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M10.2226 13.9993C10.2222 10.8704 10.2227 9.04524 10.2227 8.49927",
      stroke: "#FFFFFF",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};

exports.default = Icon;